<template>
  <nav class="pagination">
    <button :disabled="currentPage === 1" @click="$emit('page-change', currentPage - 1)">Prev</button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button :disabled="currentPage === totalPages" @click="$emit('page-change', currentPage + 1)">Next</button>
  </nav>
</template>
<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
const props = defineProps<{ currentPage: number; totalPages: number }>();
defineEmits(['page-change']);
</script>
<style scoped>
.pagination {
  display: flex;
  gap: 1rem;
  align-items: center;
}
button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
